import { render, staticRenderFns } from "./productionReturn.vue?vue&type=template&id=de434846&scoped=true"
import script from "./productionReturn.vue?vue&type=script&lang=js"
export * from "./productionReturn.vue?vue&type=script&lang=js"
import style0 from "./productionReturn.vue?vue&type=style&index=0&id=de434846&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de434846",
  null
  
)

export default component.exports